// extracted by mini-css-extract-plugin
module.exports = {"socials":"social-block-module--socials--RTd2i","iconLink":"social-block-module--icon-link--3Xort"};